import {
  LOGIN_SUCCESS,
  LOGOUT,
} from '../actions/Auth.js';

import {
  DETECTION_CREATE_MEMBER,
} from '../actions/Detection.js';

import {
  SELECTION_FETCHED_ERROR,
} from '../actions/Selection.js';

const accessToken = localStorage.getItem('accessToken') || '';
const tester = localStorage.getItem('tester') || '';
const phone = localStorage.getItem('phone') || '';
const birthday = localStorage.getItem('birthday') || '';
const mobilePhone = localStorage.getItem('mobilePhone') || '';
const customerId = localStorage.getItem('customerId') || '';

const initialState = Object.assign({
  name: '',
  account: '',
  role: '',
  email: '',
  id: -1,
  customerId,
  accessToken,
  tester,
  phone,
  birthday,
  mobilePhone,
  isLogined: !!localStorage.getItem('accessToken') || false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case SELECTION_FETCHED_ERROR:
      localStorage.removeItem('accessToken');

      return Object.assign({}, state, {
        name: '',
        account: '',
        id: -1,
        isLogined: false,
      });
    case DETECTION_CREATE_MEMBER:
      try {
        localStorage.setItem('tester', action.tester);
        localStorage.setItem('phone', action.phone);
        localStorage.setItem('birthday', action.birthday);
        localStorage.setItem('mobilePhone', action.mobilePhone);
        localStorage.setItem('customerId', action.id);
      } catch (ex) {
        console.warn(ex);
      }
      return Object.assign({}, state, {
        tester: action.tester,
        phone: action.phone,
        birthday: action.birthday,
        mobilePhone: action.mobilePhone,
        customerId: action.id,
      });

    case LOGOUT:
      localStorage.removeItem('accessToken');

      return Object.assign({}, state, {
        name: '',
        account: '',
        id: -1,
        isLogined: false,
      });

    case LOGIN_SUCCESS:
      try {
        localStorage.setItem('accessToken', action.accessToken.token);
      } catch (ex) {
        console.warn(ex);
      }

      return Object.assign({}, state, {
        id: action.id,
        name: action.member.name,
        account: action.member.account,
        role: action.member.role,
        email: action.member.email,
        passwordVersion: Date.now(),
        isLogined: true,
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/Auth.js